import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Trailer } from 'src/app/core/interfaces/trailer';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { environment } from 'src/environments/environment';
import { Utils } from 'src/app/core/resources/utils';

@Injectable({
  providedIn: 'root'
})
export class TrailersService {
  constructor(
    private readonly http: HttpClient,
    private readonly endpoints: Endpoints,
    private readonly utils: Utils
  ) { }

  getTrailers(
    pageKey: number,
    pageSize: number,
    id?: string,
    owner?: string,
    vehicle?: string,
    holderCompanyId?: string,
    ministryManualAdjustment?: boolean
  ): Observable<Trailer[]> {
    const params = new URLSearchParams();

    if (id) params.set('id', id);
    if (owner) params.set('owner', owner);
    if (vehicle) params.set('vehicle', vehicle);
    if (holderCompanyId) params.set('holderCompany', holderCompanyId);
    if (this.utils.isDefined(ministryManualAdjustment)) params.set('ministryManualAdjustment', ministryManualAdjustment.toString());
    params.set('pageKey', `${pageKey}`);
    params.set('pageSize', `${pageSize}`);

    return this.http.get(
      `${environment.urlServerTeclogi}${this.endpoints.listTrailer}${params.toString()}`
    ) as Observable<Trailer[]>;
  }

  getTrailersByCompany(options: {
    companyId: string; pageKey?: number; pageSize?: number; id?: string; ministryRetry?: boolean; ministryManualAdjustment?: boolean;
  }): Observable<Trailer[]> {
    let params = new HttpParams().set('companyId', options.companyId);
    if (this.utils.isDefined(options.pageKey)) params = params.set('pageKey', options.pageKey.toString());
    if (options.pageSize) params = params.set('pageSize', options.pageSize.toString());
    if (options.id) params = params.set('id', options.id.trim().toUpperCase());
    if (this.utils.isDefined(options.ministryRetry)) params = params.set('ministryRetry', options.ministryRetry.toString());
    if (this.utils.isDefined(options.ministryManualAdjustment)) params = params.set('ministryManualAdjustment', options.ministryManualAdjustment.toString());
    return this.http.get<Trailer[]>(
      `${environment.urlServerTeclogi}${this.endpoints.getTrailersByCompany}`,
      { params }
    );
  }

  public trailerMinistryRetry(licensePlate: string): Observable<Trailer> {
    const params = new HttpParams().set('licensePlate', licensePlate.trim().toUpperCase());
    return this.http.post<Trailer>(
      `${environment.urlServerTeclogi}${this.endpoints.trailerMinistryRetry}`,
      {},
      { params }
    );
  }
}
